import { MapMarker, MarkerClusterer } from 'react-kakao-maps-sdk';

export interface ComplexMarker {
  regionCode: string;
  dong: string;
  aptName: string;
  lat: number;
  lng: number;
  latestDealAmount: number | null;
  latestDealYmd: string | null;
  dealCount: number;
}

interface ComplexMarkerLayerProps {
  complexes: ComplexMarker[];
  /** true(줌 10~11, 시군구+단지): 촘촘한 단지는 클러스터로 묶음. false(줌 12+, 동네): 개별 마커 풀 표시 */
  clustered: boolean;
  onComplexClick: (complex: ComplexMarker) => void;
}

/** 줌 10+ 개별 단지(아파트) 마커 레이어. react-kakao-maps-sdk 내장 MarkerClusterer 사용(신규 의존성 없음). */
export function ComplexMarkerLayer({ complexes, clustered, onComplexClick }: ComplexMarkerLayerProps) {
  const markers = complexes.map((c) => (
    <MapMarker
      key={`${c.regionCode}-${c.dong}-${c.aptName}`}
      position={{ lat: c.lat, lng: c.lng }}
      title={c.aptName}
      onClick={() => onComplexClick(c)}
    />
  ));

  if (!clustered) return <>{markers}</>;

  return (
    <MarkerClusterer gridSize={60} averageCenter minLevel={0}>
      {markers}
    </MarkerClusterer>
  );
}
